module.exports = __webpack_public_path__ + "files/672c96197e82b9e38e0feb8267cf10d8.eot";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_AMS-Regular.eot
// module id = 458
// module chunks = 76